import React from 'react';
import PricingSection from '../components/PricingSection';
import { useTheme } from '../contexts/ThemeContext';
import { useContent } from '../hooks/useContent';

const Pricing = () => {
  const { content, loading: contentLoading } = useContent('pricing');
  const { isDark } = useTheme();
  if (contentLoading || !content) {

    return (
      <div className={`pt-16 min-h-screen flex items-center justify-center ${isDark ? 'bg-dark-900' : 'bg-gray-50'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  return (
    <div className="pt-16 min-h-screen bg-dark-900">
      <section className="relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white mb-4">{content.mainHeader}</h1>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">{content.subHeader}</p>
        </div>
      </section>

      <PricingSection />
    </div>
  );
};

export default Pricing;
